(function($) {

	'use strict'

	var init = function() {
		initLabMap();
		initPrepareSection();
	}

	var initPrepareSection = function(){
		$('select.lab__venir__section__content').on('change', analysisSelect);
	}

	var analysisSelect = function(e){
		var analysisId = $(this).val();
		for(var i = 2; i<=3; i++){
			var container = $('.lab__venir__section--'+i);
			var contentBloc = container.find('[data-analysis="'+analysisId+'"]');

			//Close previously openned blocs
			container.find('.lab__venir__section__content.active').slideUp(300).removeClass('active');

			if(contentBloc.length && analysisId){
				//Open container if needed
				if(!container.hasClass('active')){
					container.addClass('active').slideDown(300);
				}
				contentBloc.addClass('active');
				window.setTimeout(function(){
					$('.lab__venir__section__content.active').slideDown(300);
				}, 300)
			} else {
				//Close container if needed
				if(container.hasClass('active')){
					container.removeClass('active').slideUp(300);
				}
			}
		}
	}

	var initLabMap = function(){
		if(!(GMAP_CI.marker.lat && GMAP_CI.marker.lng)){
			return ;
		}
		var map = L.map('lab-map').setView([GMAP_CI.marker.lat, GMAP_CI.marker.lng], 12);
		var markerOB = L.icon({
			iconUrl: GMAP_CI.icon,
			iconSize:     [40, 40],
			iconAnchor:   [20, 40], // point of the icon which will correspond to marker's location
		});
		var marker = L.marker([GMAP_CI.marker.lat, GMAP_CI.marker.lng], {icon: markerOB}).addTo(map);

		L.tileLayer('https://maps.geoapify.com/v1/tile/osm-liberty/{z}/{x}/{y}.png?apiKey=218483ba811e467eadbcdac1906953b7', {
			maxZoom: 19,
			attribution: 'Powered by <a href="https://www.geoapify.com/" target="_blank">Geoapify</a> | © OpenStreetMap <a href="https://www.openstreetmap.org/copyright" target="_blank">contributors</a>'
		}).addTo(map);		
	}

	$(document).ready(function() {
		if($('.lab__informations__map').length > 0) {
			init();
		}
	});

})(jQuery)